import './Layout.scss';

import { FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CircularProgress } from '@mui/material';

import Header from 'app/components/Header/Header';

import { useTranslation } from 'react-i18next';
import { supportedLocaleCodes } from 'app/configs/appConfig';
import Cookies from 'js-cookie';

const Layout: FC = () => {
  const { i18n } = useTranslation();

  const previousSiteLng = Cookies.get('id_site_language');
  const localStorageLng = i18n.language;

  if (localStorageLng && previousSiteLng && localStorageLng !== previousSiteLng) {
    if (supportedLocaleCodes.includes(previousSiteLng)) {
      i18n.changeLanguage(previousSiteLng);
    }
  }

  return (
    <div className="layout">
      <Header />
      <main className="content-wrapper">
        <Suspense
          fallback={<CircularProgress color="inherit" className="content-wrapper__loading" />}
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};

export default Layout;
